import { render, staticRenderFns } from "./HMAlert.vue?vue&type=template&id=08b45bb4&"
import script from "./HMAlert.vue?vue&type=script&lang=js&"
export * from "./HMAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports